import axios from 'axios';
import sentry from '@/analytics/sentry';

export default async function queryContentRisk({ content, subject }) {
    const contentRiskListRequest = {
        subject,
        content,
    };

    try {
        const { data } = await axios.post(
            '/app/unlayerEmailFunnel/contentRisk/list',
            contentRiskListRequest,
        );

        const { quality, details } = data;

        return {
            quality,
            details,
        };
    } catch (error) {
        sentry.captureException(
            new Error('Failed to fetch content risk', { cause: error }),
            {
                data: {
                    subject,
                    content,
                }
            }
        );

        throw error;
    }
}
